import { FacetedSearch } from './FacetedSearch.component';

export { FacetedSearch };
